import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { StupidSalesWidget } from '../widget/StupidSalesWidget';
import { LiveStreamWidget } from '../widget/LiveStreamWidget';
import config from '../config';

const LandingPage = () => {
  const { user } = useAuth();
  const [isLiveStreamVisible, setIsLiveStreamVisible] = useState(false);

  const widgetConfig = {
    companyId: '1ba4715d-28e4-4621-8527-f00adcf7fb17',
    apiKey: 'ss_27d43b1d-3003-4026-9c92-0cd50ca0b299',
    backendUrl: window.location.hostname === 'localhost' 
      ? 'http://localhost:5001'
      : 'https://video-embed-backend.onrender.com',
    theme: {
      primaryColor: '#33D298',
      primaryHoverColor: '#2BB583',
      spinnerColor: '#33D298'
    },
    greetingsMessage: "I'm ready to chat now!"
  };

  useEffect(() => {
    const checkStreamStatus = async () => {
      try {
        const response = await fetch(`${widgetConfig.backendUrl}/api/stream-status/${widgetConfig.companyId}`);
        const data = await response.json();
        setIsLiveStreamVisible(data.live_status);
      } catch (error) {
        console.error('Error checking stream status:', error);
      }
    };

    checkStreamStatus();
  }, []);

  return (
    <div className="page-wrapper">
      <nav className="top-nav">
        <div className="nav-content">
          <div className="logo">
            <img 
              src="/images/angry_avatar.png" 
              alt="Stupid Sales Logo" 
              className="avatar"
            />
            <span className="logo-text">
              <span className="name">Stupid</span>
              <span className="time">Sales</span>
            </span>
          </div>
        </div>
      </nav>

      <header className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-highlight">Live Video Chat</span>
            <span className="title-main">On Your Website</span>
          </h1>
          <p className="hero-subtitle">
            The opposite of AI chatbots
          </p>
        </div>
      </header>

      <main className="main-content">
        {isLiveStreamVisible && (
          <>
            <div style={{ height: '2rem' }} />
            <LiveStreamWidget config={widgetConfig} />
          </>
        )}
        
        <StupidSalesWidget config={widgetConfig} />
        
        <section className="video-section">
          <div className="video-wrapper">
            <iframe 
              src="https://www.youtube.com/embed/GN7Kko0RQl0?vq=hd1080" 
              title="Product Demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
              className="video-frame"
            />
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <p className="copyright">© 2025 Stupid Sales Inc.</p>
        </div>
        <div className="footer-links">
          <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
          {/* <span className="separator">|</span>
          <a href="/terms-of-service" className="footer-link">Terms of Service</a> */}
      </div>
      </footer>
    </div>


  );
};

export default LandingPage; 